import { createApp } from "vue";
import webSdk from "@xyz-sdk/core";
import WebPerformance from "@xyz-sdk/performance";
import RecordScreen from "@xyz-sdk/recordscreen";
import "element-plus/es/components/message/style/css";

import App from "./App.vue";

// 监控平台自己也是 web-sdk 的接入方：首页的测试按钮触发的异常都会上报到 /report
// 录屏时长 15s，平衡及时性和上下文完整性
webSdk.use(RecordScreen, { recordScreenDuration: 15 });
webSdk.use(WebPerformance, {});
const reportBase = import.meta.env.VITE_API_BASE || location.origin;

webSdk.init({
  dsn: `${reportBase}/report`,
  apiKey: "sdk-monitor",
  release: import.meta.env.VITE_APP_VERSION || "dev",
  monitorWhiteScreen: true,
  recordScreenTypeList: [
    "error",
    "unhandledrejection",
    "resource",
    "fetch",
    "xhr",
  ],
});

const app = createApp(App);

// Vue 3 错误处理
app.config.errorHandler = (err: unknown) => {
  webSdk.errorBoundary(err as Error);
};

app.mount("#app");
